export const emailSubjects = {
    question: 'Vraag',
    compliment: 'Compliment',
    complaint: 'Klacht',
    change: 'Wijziging',
    viewPrescriptionInfo: 'Inzage oogmeetgegevens',
    viewPersonalInfo: 'Inzage persoonsgegevens (AVG)',
    deletePersonalInfo: 'Verwijderen persoonsgegevens',
    movePersonalInfo: 'Overdragen persoonsgegevens',
};

export const stepComponentNames = {
    answerSelect: 'answerSelect',
    subjectSelect: 'subjectSelect',
    storeSelect: 'storeSelect',
    storeSelectOptional: 'storeSelectOptional',
    privacyMessage: 'privacyMessage',
    orderNumberForm: 'orderNumberForm',
    nameForm: 'nameForm',
    addressForm: 'addressForm',
    messageForm: 'messageForm',
};

export const stepNames = {
    subscriptionQuestion: 'subscriptionQuestion',
    subjectSelect: 'subjectSelect',
    purchaseCheck: 'purchaseCheck',
    purchaseComplaint: 'purchaseComplaint',
    purchaseChange: 'purchaseChange',
    storeComplimentCheck: 'storeComplimentCheck',
    privacyMessage: 'privacyMessage',
    purchaseReceiptCheck: 'purchaseReceiptCheck',
    receiptInfoCheck: 'receiptInfoCheck',
    purchaseTypeCheck: 'purchaseTypeCheck',
    storeSelect: 'storeSelect',
    storeSelectOptional: 'storeSelectOptional',
    orderNumberCheck: 'orderNumberCheck',
    customerContact: 'customerContact',
    customerAddress: 'customerAddress',
    customerMessage: 'customerMessage',
};

export const formFields = {
    company: 'company',
    subject: 'subject',
    orderNumber: 'orderNumber',
    salutation: 'salutation',
    firstName: 'firstName',
    lastNamePrefix: 'lastNamePrefix',
    lastName: 'lastName',
    street: 'street',
    houseNumber: 'houseNumber',
    houseNumberAddition: 'houseNumberAddition',
    zipcode: 'zipcode',
    city: 'city',
    phoneNumber: 'phoneNumber',
    customerEmail: 'customerEmail',
    message: 'message',
    store: 'store',
    sendToDeliveryService: 'sendToDeliveryService',
    contactPreference: 'contactPreference',
};
